import CommonImage from '@/components/CommonImage';

const ConstingListView = ({
	listViewResponse,
	selectedSampleItem,
	handleSelectSampleItem,
	handleSelectAllSampleItem,
	onClickDesignImage
}) => {
	const renderConstingListViewRow = (item, idx) => {
		return (
			<>
				<tr key={`${item.id}_${idx}`}>
					<td className="checkbox-column cursor-pointer">
						<div className="custom-chekbox">
							<div className="form-group m-0">
								<input
									type="checkbox"
									id={`${item?.id}-${idx}`}
									name={`sample_${item?.id}`}
									value={item?.id}
									onChange={(e) => handleSelectSampleItem(e, item)}
									checked={selectedSampleItem.includes(parseInt(item?.id))}
								/>
								<label htmlFor={`${item?.id}-${idx}`} />
							</div>
						</div>
					</td>
					<td
						rowSpan={item?.costingJourneyDetailsResponse?.quoteItemResponse?.noOfSameVariant || 1}
						className={`image-column cursor-pointer ${item?.costingJourneyDetailsResponse?.quoteItemResponse?.isSameVariant ? 'd-none' : ''}`}
						onClick={() => onClickDesignImage(item?.id)}
					>
						<div className="d-flex align-items-center justify-content-center">
							<img src={item.designDocuments?.[0]?.docUrl} alt="" className="cell-img pr-2" />
						</div>
					</td>
					<td
						className={`style-details-column ${item?.costingJourneyDetailsResponse?.quoteItemResponse?.isSameVariant ? 'd-none' : ''}`}
						rowSpan={item?.costingJourneyDetailsResponse?.quoteItemResponse?.noOfSameVariant || 1}
					>
						<p className="semibold-14 gray_dark_01 mb-4">{item?.systemReferenceNumber}</p>
						<p className="regular-14 gray_dark_02 mb-0">{item?.productGroup}</p>
						<p className="regular-14 gray_dark_02 mb-0">{item?.mainFabricType}</p>
					</td>
					<td
						className={`body-fabric-column ${item?.costingJourneyDetailsResponse?.quoteItemResponse?.isSameVariant ? 'd-none' : ''}`}
						rowSpan={item?.costingJourneyDetailsResponse?.quoteItemResponse?.noOfSameVariant || 1}
					>
						<p className="regular-14 gray_dark_02 mb-0">{item?.fabricDetails}</p>
					</td>
					<td
						className={`print-embo-column ${item?.costingJourneyDetailsResponse?.quoteItemResponse?.isSameVariant ? 'd-none' : ''}`}
						rowSpan={item?.costingJourneyDetailsResponse?.quoteItemResponse?.noOfSameVariant || 1}
					>
						<p className="regular-14 gray_dark_02 mb-0">
							Print:{item?.costingJourneyDetailsResponse?.printTypes?.join(', ')}
						</p>
						<p className="regular-14 gray_dark_02 mb-0">
							Embo:{item?.factoryDevelopmentJourneyDetails?.emboTypes?.join(', ')}
						</p>
					</td>
					<td
						className={`wash-column ${item?.costingJourneyDetailsResponse?.quoteItemResponse?.isSameVariant ? 'd-none' : ''}`}
						rowSpan={item?.costingJourneyDetailsResponse?.quoteItemResponse?.noOfSameVariant || 1}
					>
						<p className="regular-14 gray_dark_02 mb-0">
							{item?.costingJourneyDetailsResponse?.washTypes?.join(', ')}
						</p>
					</td>
					<td className="qty-column">
						<p className="regular-14 gray_dark_02 mb-0">
							{item?.costingJourneyDetailsResponse?.quoteItemResponse?.quantity}
						</p>
					</td>
					<td className="buyer-target-price-column">
						<p className="regular-14 gray_dark_02 mb-0">-</p>
					</td>
					<td className="production-price-column">
						<p className="regular-14 gray_dark_02 mb-0">
							{item?.productionPrice ? (
								`$${parseFloat(item?.productionPrice).toFixed(2)}`
							) : (
								<span className="gray_dark_02 add-price">Add price</span>
							)}
						</p>
					</td>
					<td className="offer-price-column">
						<p className="regular-14 gray_dark_02 mb-0">-</p>
					</td>
					<td
						className={`remarks-column ${item?.costingJourneyDetailsResponse?.quoteItemResponse?.isSameVariant ? 'd-none' : ''}`}
						rowSpan={item?.costingJourneyDetailsResponse?.quoteItemResponse?.noOfSameVariant || 1}
					>
						<p className="regular-14 gray_dark_02 mb-0">-</p>
					</td>
					<td
						className={`last-status-column ${item?.costingJourneyDetailsResponse?.quoteItemResponse?.isSameVariant ? 'd-none' : ''}`}
						rowSpan={item?.costingJourneyDetailsResponse?.quoteItemResponse?.noOfSameVariant || 1}
					>
						<span className="status yellow-1 status-with-border d-inline-block mb-1">
							{item?.costingJourneyDetailsResponse?.lastStatusName}
						</span>
						<p className="regular-12 gray_dark_02 mb-0">
							{item?.costingJourneyDetailsResponse?.lastStatusDate},
							{item?.costingJourneyDetailsResponse?.lastStatusByName}
						</p>
					</td>
					<td
						className={`lead-time-column ${item?.costingJourneyDetailsResponse?.quoteItemResponse?.isSameVariant ? 'd-none' : ''}`}
						rowSpan={item?.costingJourneyDetailsResponse?.quoteItemResponse?.noOfSameVariant || 1}
					>
						<p className="regular-12 gray_dark_02 mb-0">
							{item?.costingJourneyDetailsResponse?.requiredLeadTimeInDays} days{' '}
						</p>
					</td>
					<td
						className={`request-column ${item?.costingJourneyDetailsResponse?.quoteItemResponse?.isSameVariant ? 'd-none' : ''}`}
						rowSpan={item?.costingJourneyDetailsResponse?.quoteItemResponse?.noOfSameVariant || 1}
					>
						<p className="regular-12 gray_dark_02 mb-0">
							Requested:{item?.costingJourneyDetailsResponse?.requestDate},{' '}
							{item?.costingJourneyDetailsResponse?.requestedByName}
						</p>
						<p className="regular-12 gray_dark_02 mb-0">
							Rcv: {item?.costingJourneyDetailsResponse?.requestReceivedDate},{' '}
							{item?.costingJourneyDetailsResponse?.requestReceivedByName}
						</p>
					</td>
					<td
						className={`required-complete-conversation-column ${item?.costingJourneyDetailsResponse?.quoteItemResponse?.isSameVariant ? 'd-none' : ''}`}
						rowSpan={item?.costingJourneyDetailsResponse?.quoteItemResponse?.noOfSameVariant || 1}
					>
						<p className="regular-12 gray_dark_02 mb-0">
							Required: {item?.costingJourneyDetailsResponse?.quoteItemResponse?.requiredDate}
						</p>
						<p className="regular-12 gray_dark_02 mb-0">
							Completed:{item?.costingJourneyDetailsResponse?.completedDate},{' '}
							{item?.costingJourneyDetailsResponse?.CompletedByName}
						</p>
						<p className="regular-12 gray_dark_02 mb-0">
							Send to buyer:{item?.costingJourneyDetailsResponse?.offerSendToBuyerDate}
						</p>
						<div className="conversation-btn">
							<button className="button text">
								<CommonImage
									className="cursor-pointer"
									src="icons/comments-gray.svg"
									width={24}
									height={24}
								/>
							</button>
						</div>
					</td>
					<td
						className={`review-column ${item?.costingJourneyDetailsResponse?.quoteItemResponse?.isSameVariant ? 'd-none' : ''}`}
						rowSpan={item?.costingJourneyDetailsResponse?.quoteItemResponse?.noOfSameVariant || 1}
					>
						<p>
							Approved by the buyer: {item?.costingJourneyDetailsResponse?.approvedByBuyerDate}
						</p>
						<p>
							Costing closed without order/Sampling:{' '}
							{item?.costingJourneyDetailsResponse?.costingClosedWithoutOrderDate}
						</p>
					</td>
				</tr>
			</>
		);
	};
	return (
		<div>
			<div className="single-table">
				<p
					className="semibold-14 text-underline mb-12 cursor-pointer"
					onClick={() =>
						window.open(
							`/quote/request/${listViewResponse?.[0]?.costingJourneyDetailsResponse?.requestId}`,
							'_blank'
						)
					}
				>
					{listViewResponse?.[0]?.costingJourneyDetailsResponse?.brandResponse?.name}
					<span>|</span>
					{listViewResponse?.[0]?.costingJourneyDetailsResponse?.requestReferenceNumber}
					<span>|</span>
					{listViewResponse?.[0]?.costingJourneyDetailsResponse?.requestName}
				</p>
				<div className="costing-details-view-table scroll-x-label">
					<table className="table with-border">
						<thead>
							<tr>
								<th>
									<div className="custom-chekbox">
										<div className="form-group m-0">
											<input
												type="checkbox"
												id="selectAllSendToPd"
												name="selectAllSendToPd"
												onChange={(e) => handleSelectAllSampleItem(e)}
												checked={
													selectedSampleItem.length === listViewResponse?.length
												}
											/>
											<label htmlFor="selectAllSendToPd" />
										</div>
									</div>
								</th>
								<th>Image</th>
								<th className="white-space-nowrap">Style details</th>
								<th className="white-space-nowrap">Body fabric</th>
								<th className="white-space-nowrap">Print, Embo</th>
								<th>Wash</th>
								<th>Qty</th>
								<th className="white-space-nowrap">Buyer target price</th>
								<th className="white-space-nowrap">Production price</th>
								<th className="white-space-nowrap">Offer price</th>
								<th>Remarks</th>
								<th className="white-space-nowrap">Last status</th>
								<th className="white-space-wrap">Lead time: Required - Costing complete</th>
								<th>Request</th>
								<th className="white-space-nowrap">Required &amp; complete</th>
								<th>Review</th>
							</tr>
						</thead>
						<tbody>
							{listViewResponse?.map((item, idx) => renderConstingListViewRow(item, idx))}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
};
export default ConstingListView;
